import { useEffect } from "react";
import { Navigate, Outlet, useParams } from "react-router";
import { useManifestStore } from "../state/manifestStore";
import { SideNav } from "./SideNav";

export function AppShell() {
  const { tenant } = useParams();
  const { manifest, error, loading, ensureLoaded } = useManifestStore();
  useEffect(() => {
    ensureLoaded();
  }, [ensureLoaded]);

  if (loading || !manifest) {
    return (
      <div className="auth-screen">
        <h1>Monitor</h1>
        <p>{error ?? "Loading…"}</p>
      </div>
    );
  }

  if (!tenant) {
    return <Navigate to={`/${manifest.tenants[0].id}`} replace />;
  }
  if (!manifest.tenants.find((t) => t.id === tenant)) {
    return <Navigate to={`/${manifest.tenants[0].id}`} replace />;
  }

  return (
    <div className="app-shell">
      <SideNav tenant={tenant} />
      <div className="app-main">
        <Outlet />
      </div>
    </div>
  );
}
